<template>
  <a-modal
    class="modal-content"
    :title="`${form.id ? '编辑' : '发布'}${title}`"
    :width="700"
    :visible="visible"
    ok-text="保存"
    @ok="handleOk"
    @cancel="hideModal"
  >
    <a-form-model
      ref="ruleForm"
      :labelCol="{ span: 2 }"
      :wrapperCol="{ span: 22 }"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item label="标题" prop="title">
        <a-input v-model="form.title" placeholder="请输入测评标题" />
      </a-form-model-item>
      <a-form-model-item label="测评" prop="evaluationId">
        <a-select v-model="form.evaluationId" :options="evalOptions" placeholder="请选择测评" />
      </a-form-model-item>
      <a-form-model-item label="封面" prop="cover" class="cover-item">
        <j-image-upload
          ref="coverRef"
          accept=".png,.jpg,.jpeg"
          v-model="form.coverUrl"
          bizPath="dayOath"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction, postAction, putAction } from '@/api/manage'
import { getStoreFileUrl } from '@/utils/util'
import moment from 'moment'
import JImageUpload from '@comp/jeecg/JImageUpload.vue'

export default {
  name: 'VideoModal',
  components: { JImageUpload },
  mixins: [JeecgListMixin],
  props: {
    title: {
      type: String,
      default: '测评',
    },
  },
  data() {
    return {
      visible: false,
      form: {},
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'change' }],
        evaluationId: [{ required: true, message: '请选择测评', trigger: 'change' }],
        coverUrl: [{ required: true, message: '请选择封面', trigger: 'change' }],
      },
      // uploadAction: window._CONFIG['domianURL'] + '/sys/common/upload?biz=studentTag',
      importExcelUrl: window._CONFIG['domianURL'] + '/sys/common/upload?biz=dayOath',
      fileList: [],
      activeKey: '5',
      isShowDetails: false,
      templateUrl: '',
      evalOptions: [],
    }
  },
  methods: {
    showModal(data = {}) {
      this.getEvalOptions()
      this.form = data
      console.log('数据：', data)
      this.visible = true
      this.fileList = []
    },
    hideModal() {
      this.visible = false
      this.form = {}
      this.fileList = []
    },
    getEvalOptions() {
      getAction('/schoolEvaluation/list', { pageNo: 1, pageSize: 100 }).then((res) => {
        console.log('获取列表数据--', res)
        if (res.success) {
          this.evalOptions =
            res.result.records?.map((item) => ({
              value: item.id,
              label: item.name,
            })) || []
        }
      })
    },
    async handleOk() {
      const params = {
        ceremonyId: this.form.ceremonyId,
        ceremonyItemId: this.form.ceremonyItemId,
        id: this.form.id,
        title: this.form.title,
        coverUrl: this.form.coverUrl,
        evaluationId: this.form.evaluationId,
        contentType: this.form.contentType,
      }
      if (this.fileList.length > 0) {
        params.url = this.fileList[this.fileList.length - 1].url
      }
      console.log('参数--', params)
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const res = params.id
            ? await putAction('/ceremonyItemContent/edit', params)
            : await postAction('/ceremonyItemContent/add', params)
          if (res.success) {
            this.$message.success(res.message)
            this.hideModal()
            this.$emit('refreshData')
          } else {
            this.$message.error(res.message || '保存失败')
          }
        }
      })
    },
    handleChange(info) {
      let fileList = [...info.fileList]
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.message
        }
        return file
      })
      this.fileList = fileList
      console.log('fileList', fileList)
    },
  },
}
</script>
<style scoped lang="less">
.modal-content {
  /deep/ .ant-modal-header {
    border-bottom: none;
  }
  /deep/ .ant-modal-body {
    padding: 0 24px 10px;
  }
  ///deep/ .ant-upload {
  //  height: 149px;
  //}
}
</style>
